import type React from "react";
import AwsCronInput from "../../../components/Forms/AwsCronInput";
import NewTextFormComponent from "../../../components/Forms/NewTextFormComponent";

interface Switch2CMI6110IntegrationFormProps {
  namespace: string;
}

export default function Switch2CMI6110IntegrationForm(
  props: Switch2CMI6110IntegrationFormProps,
): React.ReactElement {
  const withNamespace = (field: string) => {
    return `${props.namespace}.${field}`;
  };
  return (
    <>
      <NewTextFormComponent
        fieldName={withNamespace("api_key")}
        label={{ label: "API Key (X-S2-KEY)" }}
      />
      <NewTextFormComponent
        fieldName={withNamespace("user_id")}
        label={{ label: "User ID (X-S2-USER)" }}
      />
      <NewTextFormComponent
        fieldName={withNamespace("site_id")}
        label={{ label: "Site ID (Optional)" }}
      />
      <AwsCronInput
        fieldName={withNamespace("device_list_cron")}
        label={{ label: "Device List Sync Schedule (Cron)" }}
      />
      <AwsCronInput
        fieldName={withNamespace("data_polling_cron")}
        label={{ label: "Data Polling Schedule (Cron)" }}
      />
    </>
  );
}
